import { useEffect, useState } from 'react'

import { Tab } from 'components'

import TalkToUsForm from './components/TalkToUsForm'
import TalkToUsSearch from './components/TalkToUsSearch'

const DEFAULT_TABS = ['Pesquisar']

const TalkToUs = () => {
  const [tabs, setTabs] = useState<string[]>(DEFAULT_TABS)
  const [selectedTab, setSelectedTab] = useState(0)
  const [idFaleConosco, setIdFaleConosco] = useState<number>(1)

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  const setToDefaultTabs = () => setTabs(() => DEFAULT_TABS)

  const handleAnswerForm = (idFaleConosco: number) => {
    if (!idFaleConosco) {
      setSelectedTab(0)
      setToDefaultTabs()
      setIdFaleConosco(null)
      return
    }

    setTabs([...DEFAULT_TABS, 'Pesquisar'])
    setIdFaleConosco(idFaleConosco)
    setSelectedTab(1)
  }

  useEffect(() => {
    if (selectedTab === 0) {
      setToDefaultTabs()
    }
  }, [selectedTab])

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 ? (
        <TalkToUsSearch handleAnswerForm={handleAnswerForm} />
      ) : (
        <>
          <TalkToUsForm
            idFaleConosco={idFaleConosco}
            setSelectedTab={setSelectedTab}
          />
        </>
      )}
    </>
  )
}

export default TalkToUs
